import React, { useEffect, useState } from "react";
import { Animate } from "react-simple-animate";
import Layout from "./Layout";
// import RestaurantHeader from "../components/restaurant/RestaurantHeader";
import axios from "axios";
import queryString from "query-string";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import ReviewRating from "../components/Layout/ReviewRating";
import Loading from "../components/Loading";
import HomeMadeCard from "../components/homemadeFoodIngredients/HomeMadeCard";
import DeliveryOption from "../components/searchRestaurant/DeliveryOption";
import FoodCategoryOption from "../components/searchRestaurant/FoodCategoryOption";
import FoodCateroryMenubar from "../components/searchRestaurant/FoodCateroryMenubar";
import HygieneCheck from "../components/searchRestaurant/HygieneCheck";
import RestaurantListCard from "../components/searchRestaurant/RestaurantListCard";
import Slider2 from "../components/slider/Slider2";
import ad1 from '../images/res-list/q 1.png';
import ad2 from '../images/res-list/r 1.png';
import { cancelReviewRating } from "../redux/actions/orderAction";
import {
  fetchFoodCategories,
  fetchRestaurantCategories,
  fetchRestaurantsByAddress,
} from "../redux/actions/restaurantAction";
import { API_URL } from "../settings/config";
import auth from "../util/auth";
function getLocationFromLocalStorage() {
  return localStorage.getItem("formatted_address")
    ? localStorage.getItem("formatted_address")
    : null;
}

const offBreakpoints = {
  425: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 1,
  },
  768: {
    slidesPerView: 3,
  },
  1024: {
    slidesPerView: 3.5,
  },
  1200: {
    slidesPerView: 4,
  },
  1400: {
    slidesPerView: 4,
  },
};

const offerBreakpoints = {
  425: {
    slidesPerView: 1.5,
  },
  576: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 2.5,
  },
  1024: {
    slidesPerView: 3.5,
  },
  1200: {
    slidesPerView: 4,
  },
  1400: {
    slidesPerView: 4.5,
  },
};
const homeMadeBreakpoints = {
  425: {
    slidesPerView: 1.4,
  },
  576: {
    slidesPerView: 2.5,
  },
  768: {
    slidesPerView: 2.5,
  },
  1024: {
    slidesPerView: 2.3,
  },
  1200: {
    slidesPerView: 2.5,
  },
  1400: {
    slidesPerView: 3.5,
  },
};

function SearchRestaurant() {
  const { restaurants, categories, foodCategories, loading } = useSelector(
    (state) => state.restaurant
  );

  // restaurants.map((r) => console.log(r.is_home_made));

  const history = useHistory();

  const [Checked, setChecked] = useState([]);
  const [hygieneOption, setHygieneOption] = useState([]);
  const [foodCategoryOption, setFoodCategoryOption] = useState([]);

  const [resOption, setResOption] = useState("delivery");
  // review rating modal
  const [review, setreview] = useState("");
  const [rating, setrating] = useState(0);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [ratingData, setRatingData] = useState({});
  // console.log(ratingData);

  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(cancelReviewRating(ratingData.order_id));
    setIsOpen(false);
    setrating(null);
    setreview("");
  };

  // const handleReviewRatingModal = () => {
  //   setIsOpen(true);
  // };

  let token = auth.getToken();

  useEffect(() => {
    checkRating();

    async function checkRating() {
      await axios
        .get(`${API_URL}/review/check/`, {
          headers: {
            Authorization: token,
          },
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data.message) {
            setIsOpen(true);
            setRatingData(res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [token]);

  const urlParams = queryString.parse(window.location.search);
  // console.log({ urlParams });

  // console.log(Checked);

  useEffect(() => {
    dispatch(fetchRestaurantCategories());
    dispatch(fetchFoodCategories());
    if (urlParams.categories) {
      setChecked([...Checked, urlParams.categories]);
      // if (Checked.length === 0) {
      //   setChecked([...Checked, urlParams.categories]);
      // } else {
      //   setChecked([...Checked, ...urlParams.categories]);
      // }
    }
    if (urlParams.hygieneOption) {
      // setHygieneOption(urlParams.hygieneOption);
      setHygieneOption([...hygieneOption, urlParams.hygieneOption]);
    }
    if (urlParams.doption) {
      setResOption(urlParams.doption);
    }
    if (urlParams.foodOption) {
      // setFoodCategoryOption(urlParams.foodOption);
      setFoodCategoryOption([...foodCategoryOption, urlParams.foodOption]);
    }
    // eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (filters) {
  //     dispatch(fetchRestaurantsByAddress({ ...filters, categories: Checked }));
  //   }
  // }, [filters]);

  useEffect(() => {
    const tempFilter = {};
    if (urlParams.categories) {
      tempFilter.categories = urlParams.categories;
      // setChecked(urlParams.categories);
    }
    if (urlParams.foodOption) {
      tempFilter.foodOption = urlParams.foodOption;
    }
    if (urlParams.hygieneOption) {
      tempFilter.hygieneOption = urlParams.hygieneOption;
    }
    if (urlParams.doption) {
      tempFilter.doption = urlParams.doption;
    }
    if (urlParams.lat) {
      tempFilter.lat = urlParams.lat;
      tempFilter.lng = urlParams.lng;
    }

    dispatch(fetchRestaurantsByAddress(tempFilter));
    // eslint-disable-next-line
  }, [window.location.search, Checked, foodCategoryOption]);

  const handleToggle = (value, option) => {
    let chooseOption = resOption;
    // let newChecked = [...Checked];
    // let newFood = [...foodCategoryOption];
    let newHygiene = [...hygieneOption];
    if (option === "hygiene") {
      const currentIndex = hygieneOption.indexOf(value);

      // newChecked = [...Checked];
      if (currentIndex === -1) {
        newHygiene.push(value);
      } else {
        newHygiene.splice(currentIndex, 1);
      }
    }
    if (option === "dropOption") {
      chooseOption = value;
      setResOption(value);
    }
    if (option === "category") {
      const currentIndex = Checked.indexOf(value);
      // console.log({ Checked, currentIndex });

      // newChecked = [...Checked];
      if (currentIndex === -1) {
        Checked.push(value);
      } else {
        Checked.splice(currentIndex, 1);
      }
    }
    if (option === "foodCategory") {
      const currentIndex = foodCategoryOption.indexOf(value);
      // console.log({ foodCategoryOption, currentIndex });
      // newChecked = [...Checked];
      if (currentIndex === -1) {
        foodCategoryOption.push(value);
        // newFood.push(value);
      } else {
        foodCategoryOption.splice(currentIndex, 1);
        // newFood.splice(currentIndex, 1);
      }
    }

    setHygieneOption(newHygiene);
    setChecked(Checked);
    setFoodCategoryOption(foodCategoryOption);

    // ?doption=${chooseOption}
    history.push({
      pathname: history.location.pathname,
      search: `?lat=${urlParams.lat}&lng=${
        urlParams.lng
      }&doption=${chooseOption}${Checked.map(
        (item) => `&categories=${encodeURIComponent(item)}`
      ).join("")}${newHygiene
        .map((hy) => `&hygieneOption=${encodeURIComponent(hy)}`)
        .join("")}${foodCategoryOption
        .map((food) => `&foodOption=${encodeURIComponent(food)}`)
        .join("")}`,
    });
  };

  const [open, setOpen] = useState(true);
  const handleExpandToggle = () => {
    setOpen(!open);
  };

  // console.log(Checked);

  // if (loading) {
  //   return <Loading />;
  // }
  // restaurants
  //   .filter((res) => res.is_home_made === true)
  //   .map((filteredItem) => console.log(filteredItem));
  console.log({restaurants})
  return (
    <Layout suggestionBar>
      {/* <button onClick={() => handleReviewRatingModal()}>Review Rating</button> */}
      <ReviewRating
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        review={review}
        setreview={setreview}
        rating={rating}
        setrating={setrating}
        ratingData={ratingData}
      />
      {/* <RestaurantHeader
        step1="search restaurant list"
        step1Link={`restaurants/?lat=${urlParams.lat}&lng=${urlParams.lng}`}
      /> */}
      <div className="res-list py-14">
        <div className="container mx-auto">
          {/* <div className="flex items-baseline py-5">
            <h3 className="font-bold text-2xl mr-2">
              {getLocationFromLocalStorage()}
            </h3>
            <button
              type="button"
              className="text-indigo-600 text-xs font-semibold"
            >
              Change location
            </button>
          </div> */}
          <div className="text-gray-600 overflow-hidden">
            <div className="-my-8 divide-y-2 divide-gray-100">
              <div className="py-8 flex flex-wrap lg:flex-nowrap">
                <div className="lg:w-1/5 w-full md:mb-0 mb-6 flex-shrink-0 flex flex-col">
                  <div className="flex">
                    {/* <svg
                      width="18"
                      height="23"
                      viewBox="0 0 18 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1756_2006)">
                        <path
                          d="M6.81685 0C7.05624 0.133911 7.13995 0.33759 7.13158 0.612164C7.11651 1.12699 7.13158 1.64238 7.12655 2.15776C7.12655 2.52461 6.95915 2.69284 6.59811 2.69397C6.05758 2.69622 5.51704 2.69622 4.97651 2.69397C4.62607 2.69397 4.45699 2.52517 4.45476 2.17633C4.45141 1.65363 4.46425 1.13036 4.44974 0.608225C4.44193 0.333652 4.52061 0.128284 4.76725 0H6.81685ZM6.22368 1.78698V0.912056H5.36098V1.78641L6.22368 1.78698Z"
                          fill="url(#paint0_linear_1756_2006)"
                        />
                        <path
                          d="M11.8485 16.7704C12.8468 17.2661 13.2491 17.9519 13.0543 18.8139C12.8791 19.5898 12.1743 20.1586 11.3981 20.1508C11.0126 20.1469 10.6398 20.0112 10.3406 19.7659C10.0415 19.5206 9.83378 19.1802 9.75143 18.8004C9.55501 17.9615 9.95511 17.2813 10.9512 16.7715C10.9512 15.9838 10.9601 15.191 10.9461 14.3982C10.9401 14.2686 10.9636 14.1392 11.015 14.0202C11.0664 13.9012 11.1442 13.7957 11.2425 13.7118C12.2765 12.744 13.3004 11.7656 14.3283 10.7911C14.3813 10.741 14.4399 10.6977 14.5431 10.6122C14.4064 10.606 14.3367 10.6004 14.2669 10.6004C13.4723 10.6004 12.6777 10.6004 11.8836 10.6004C11.5974 10.6004 11.4048 10.4068 11.4087 10.1463C11.4126 9.89535 11.6013 9.71699 11.8752 9.70574C11.935 9.70574 11.9941 9.70574 12.0538 9.70574C13.1302 9.70574 14.2072 9.70968 15.2836 9.70011C15.4037 9.69328 15.5184 9.64749 15.6106 9.56958C15.8757 9.34171 16.1234 9.09301 16.4058 8.82576H1.61831C1.7076 8.91859 1.78572 9.00524 1.86719 9.08457C3.50925 10.6461 5.15262 12.2063 6.79728 13.7653C6.87829 13.836 6.94247 13.9242 6.98507 14.0234C7.02766 14.1225 7.04759 14.2301 7.04337 14.338C7.03388 15.0132 7.04337 15.6856 7.03834 16.3591C7.03834 16.6123 6.89326 16.7934 6.68121 16.8379C6.58209 16.8589 6.47881 16.8443 6.38918 16.7968C6.29954 16.7492 6.22916 16.6716 6.19016 16.5774C6.15996 16.4857 6.14617 16.3893 6.14942 16.2927C6.14607 15.73 6.14384 15.1674 6.14942 14.6081C6.1539 14.5425 6.14329 14.4767 6.11842 14.4159C6.09354 14.3551 6.05507 14.3009 6.00601 14.2576C4.09498 12.4485 2.18656 10.6369 0.280743 8.82294C0.201738 8.75492 0.131445 8.67724 0.0714857 8.59169C0.0302532 8.52695 0.00648894 8.45247 0.00254064 8.37563C-0.00140766 8.29878 0.0145969 8.22223 0.0489729 8.15353C0.0833489 8.08484 0.134907 8.02637 0.198552 7.98392C0.262197 7.94146 0.335729 7.91648 0.411879 7.91145C0.486095 7.9047 0.560312 7.90864 0.635086 7.90864H7.30898V7.66388C7.30898 7.30435 7.30508 6.94482 7.30898 6.58585C7.31289 6.30452 7.47639 6.11547 7.74033 6.11322C8.57885 6.10572 9.41774 6.10572 10.257 6.11322C10.5198 6.11322 10.6856 6.30565 10.69 6.58416C10.6973 7.01065 10.6956 7.43714 10.6989 7.86419C10.6989 7.86981 10.7068 7.87544 10.7201 7.89344H11.7642V7.66388C11.7642 7.00502 11.7642 6.34616 11.7642 5.6873C11.7642 5.267 11.9221 5.1027 12.3417 5.10158C13.5672 5.09895 14.7924 5.09895 16.0174 5.10158C16.4248 5.10158 16.5754 5.26475 16.5754 5.67829C16.5754 6.40974 16.5754 7.14118 16.5754 7.90582H17.4292C17.7361 7.90582 17.8979 7.99135 17.9699 8.20234C18.0525 8.44428 17.9348 8.61533 17.7674 8.77399C15.8511 10.5887 13.9353 12.4031 12.0198 14.2171C11.9591 14.2691 11.9114 14.3347 11.8804 14.4087C11.8494 14.4826 11.836 14.5629 11.8412 14.643C11.854 15.3553 11.8485 16.0659 11.8485 16.7704ZM15.6687 7.89795V6.02826H12.6732V7.89795H15.6687ZM11.4032 19.2365C11.6125 19.2375 11.8138 19.1555 11.9637 19.0081C12.1135 18.8607 12.1998 18.6598 12.2039 18.4488C12.2042 18.2374 12.1218 18.0344 11.9746 17.8838C11.8274 17.7333 11.6273 17.6474 11.4177 17.6447C11.3121 17.6428 11.2071 17.6621 11.109 17.7014C11.0108 17.7408 10.9214 17.7995 10.846 17.8741C10.7706 17.9487 10.7106 18.0376 10.6697 18.1358C10.6287 18.234 10.6076 18.3394 10.6074 18.4459C10.6105 18.6567 10.6957 18.8577 10.8446 19.0057C10.9935 19.1536 11.1941 19.2365 11.4032 19.2365ZM8.20907 7.01684V7.89401H9.7877V7.01684H8.20907Z"
                          fill="url(#paint1_linear_1756_2006)"
                        />
                        <path
                          d="M3.4885 7.00721C3.02869 7.00721 2.56889 7.01002 2.10908 7.00721C1.77427 7.00721 1.60686 6.83447 1.60407 6.49463C1.60073 5.57526 1.60073 4.65627 1.60407 3.73765C1.60407 3.41356 1.77929 3.2397 2.10015 3.23858C3.01196 3.23558 3.92338 3.23558 4.83444 3.23858C5.16925 3.23858 5.34168 3.41413 5.3428 3.75115C5.3454 4.6634 5.3454 5.57545 5.3428 6.48732C5.3428 6.83672 5.16925 7.00721 4.82161 7.00889C4.37798 7.00946 3.93324 7.00721 3.4885 7.00721ZM4.44941 4.14726H2.5103V6.09178H4.44941V4.14726Z"
                          fill="url(#paint2_linear_1756_2006)"
                        />
                        <path
                          d="M8.28561 21.2882C8.28612 21.513 8.24262 21.7356 8.15759 21.9433C8.07256 22.1511 7.94769 22.3399 7.79013 22.4988C7.63257 22.6578 7.44543 22.7838 7.23944 22.8697C7.03346 22.9556 6.81269 22.9996 6.58979 22.9992C6.14348 22.9955 5.71647 22.8152 5.40081 22.497C5.08515 22.1789 4.90613 21.7484 4.90234 21.2983C4.90353 20.8445 5.08309 20.4096 5.40169 20.089C5.72029 19.7684 6.15194 19.5882 6.60207 19.5879C7.04824 19.5906 7.47534 19.7706 7.79057 20.089C8.10581 20.4074 8.2837 20.8383 8.28561 21.2882ZM7.39278 21.2826C7.38551 21.0712 7.29802 20.8708 7.14838 20.7226C6.99874 20.5745 6.79837 20.4899 6.58867 20.4864C6.37893 20.4929 6.1796 20.5801 6.03169 20.7302C5.88378 20.8802 5.79854 21.0818 5.7935 21.2933C5.7935 21.7305 6.18411 22.1136 6.61044 22.1001C6.82043 22.0919 7.01918 22.0023 7.16532 21.85C7.31146 21.6977 7.39373 21.4945 7.39501 21.2826H7.39278Z"
                          fill="url(#paint3_linear_1756_2006)"
                        />
                        <path
                          d="M10.2557 10.6005C10.1396 10.6011 10.0277 10.5563 9.94368 10.4755C9.85962 10.3947 9.80985 10.2843 9.8048 10.1673C9.80346 10.1073 9.81402 10.0477 9.83585 9.99191C9.85769 9.93613 9.89036 9.8853 9.93195 9.84243C9.97353 9.79955 10.0232 9.76549 10.078 9.74224C10.1328 9.71899 10.1917 9.70702 10.2512 9.70703C10.3675 9.70878 10.4785 9.75621 10.5606 9.83922C10.6427 9.92223 10.6895 10.0343 10.6909 10.1515C10.6897 10.2685 10.6437 10.3805 10.5627 10.4641C10.4816 10.5477 10.3716 10.5966 10.2557 10.6005Z"
                          fill="url(#paint4_linear_1756_2006)"
                        />
                        <path
                          d="M7.0354 18.2098C7.03357 18.3268 6.98771 18.4388 6.9071 18.523C6.8265 18.6072 6.71717 18.6573 6.60126 18.6633C6.48521 18.665 6.37305 18.6211 6.28857 18.5409C6.20409 18.4606 6.15392 18.3504 6.14871 18.2334C6.14663 18.1735 6.15643 18.1138 6.17754 18.0578C6.19866 18.0018 6.23066 17.9505 6.27167 17.9071C6.31268 17.8637 6.36187 17.829 6.41636 17.8051C6.47085 17.7811 6.52954 17.7684 6.58899 17.7676C6.70502 17.7709 6.81552 17.8183 6.89832 17.9003C6.98112 17.9823 7.03009 18.0929 7.0354 18.2098Z"
                          fill="url(#paint5_linear_1756_2006)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_1756_2006"
                          x1="5.79068"
                          y1="0"
                          x2="5.79068"
                          y2="2.69566"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1756_2006"
                          x1="8.99946"
                          y1="5.09961"
                          x2="8.99946"
                          y2="20.1508"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_1756_2006"
                          x1="3.47316"
                          y1="3.23633"
                          x2="3.47316"
                          y2="7.00898"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_1756_2006"
                          x1="6.59398"
                          y1="19.5879"
                          x2="6.59398"
                          y2="22.9992"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <linearGradient
                          id="paint4_linear_1756_2006"
                          x1="10.2478"
                          y1="9.70703"
                          x2="10.2478"
                          y2="10.6005"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <linearGradient
                          id="paint5_linear_1756_2006"
                          x1="6.59192"
                          y1="17.7676"
                          x2="6.59192"
                          y2="18.6634"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#0DC1D9" />
                          <stop offset="1" stopColor="#E64A19" />
                        </linearGradient>
                        <clipPath id="clip0_1756_2006">
                          <rect width="18" height="23" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> */}
<svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.81685 0C7.05624 0.133911 7.13995 0.33759 7.13158 0.612164C7.11651 1.12699 7.13158 1.64238 7.12655 2.15776C7.12655 2.52461 6.95915 2.69284 6.59811 2.69397C6.05758 2.69622 5.51704 2.69622 4.97651 2.69397C4.62607 2.69397 4.45699 2.52517 4.45476 2.17633C4.45141 1.65363 4.46425 1.13036 4.44974 0.608225C4.44193 0.333652 4.52061 0.128284 4.76725 0H6.81685ZM6.22368 1.78698V0.912056H5.36098V1.78641L6.22368 1.78698Z" fill="#0DC1D9"/>
<path d="M11.8475 16.7704C12.8458 17.2661 13.2481 17.9519 13.0534 18.8139C12.8781 19.5898 12.1734 20.1586 11.3972 20.1508C11.0116 20.1469 10.6388 20.0112 10.3397 19.7659C10.0405 19.5206 9.8328 19.1802 9.75045 18.8004C9.55403 17.9615 9.95413 17.2813 10.9502 16.7715C10.9502 15.9838 10.9591 15.191 10.9452 14.3982C10.9391 14.2686 10.9626 14.1392 11.014 14.0202C11.0654 13.9012 11.1432 13.7957 11.2415 13.7118C12.2755 12.744 13.2994 11.7656 14.3273 10.7911C14.3803 10.741 14.4389 10.6977 14.5422 10.6122C14.4054 10.606 14.3357 10.6004 14.2659 10.6004C13.4713 10.6004 12.6767 10.6004 11.8826 10.6004C11.5964 10.6004 11.4039 10.4068 11.4078 10.1463C11.4117 9.89535 11.6003 9.71699 11.8743 9.70574C11.934 9.70574 11.9931 9.70574 12.0528 9.70574C13.1293 9.70574 14.2062 9.70968 15.2826 9.70011C15.4028 9.69328 15.5174 9.64749 15.6096 9.56958C15.8747 9.34171 16.1225 9.09301 16.4048 8.82576H1.61734C1.70662 8.91859 1.78474 9.00524 1.86621 9.08457C3.50827 10.6461 5.15164 12.2063 6.7963 13.7653C6.87731 13.836 6.94149 13.9242 6.98409 14.0234C7.02669 14.1225 7.04661 14.2301 7.04239 14.338C7.0329 15.0132 7.04239 15.6856 7.03737 16.3591C7.03737 16.6123 6.89228 16.7934 6.68024 16.8379C6.58111 16.8589 6.47784 16.8443 6.3882 16.7968C6.29857 16.7492 6.22819 16.6716 6.18918 16.5774C6.15899 16.4857 6.14519 16.3893 6.14844 16.2927C6.1451 15.73 6.14286 15.1674 6.14844 14.6081C6.15293 14.5425 6.14231 14.4767 6.11744 14.4159C6.09256 14.3551 6.05409 14.3009 6.00503 14.2576C4.09401 12.4485 2.18558 10.6369 0.279766 8.82294C0.200762 8.75492 0.130468 8.67724 0.0705092 8.59169C0.0292766 8.52695 0.00551238 8.45247 0.00156407 8.37563C-0.00238423 8.29878 0.0136204 8.22223 0.0479963 8.15353C0.0823723 8.08484 0.13393 8.02637 0.197575 7.98392C0.261221 7.94146 0.334753 7.91648 0.410902 7.91145C0.485119 7.9047 0.559335 7.90864 0.63411 7.90864H7.30801V7.66388C7.30801 7.30435 7.3041 6.94482 7.30801 6.58585C7.31191 6.30452 7.47541 6.11547 7.73936 6.11322C8.57787 6.10572 9.41676 6.10572 10.256 6.11322C10.5188 6.11322 10.6846 6.30565 10.689 6.58416C10.6963 7.01065 10.6946 7.43714 10.698 7.86419C10.698 7.86981 10.7058 7.87544 10.7192 7.89344H11.7632V7.66388C11.7632 7.00502 11.7632 6.34616 11.7632 5.6873C11.7632 5.267 11.9211 5.1027 12.3408 5.10158C13.5662 5.09895 14.7914 5.09895 16.0164 5.10158C16.4238 5.10158 16.5745 5.26475 16.5745 5.67829C16.5745 6.40974 16.5745 7.14118 16.5745 7.90582H17.4282C17.7351 7.90582 17.897 7.99135 17.9689 8.20234C18.0515 8.44428 17.9338 8.61533 17.7664 8.77399C15.8502 10.5887 13.9343 12.4031 12.0188 14.2171C11.9582 14.2691 11.9104 14.3347 11.8794 14.4087C11.8484 14.4826 11.835 14.5629 11.8402 14.643C11.8531 15.3553 11.8475 16.0659 11.8475 16.7704ZM15.6677 7.89795V6.02826H12.6722V7.89795H15.6677ZM11.4022 19.2365C11.6115 19.2375 11.8129 19.1555 11.9627 19.0081C12.1125 18.8607 12.1988 18.6598 12.2029 18.4488C12.2033 18.2374 12.1209 18.0344 11.9737 17.8838C11.8265 17.7333 11.6263 17.6474 11.4167 17.6447C11.3111 17.6428 11.2061 17.6621 11.108 17.7014C11.0098 17.7408 10.9204 17.7995 10.845 17.8741C10.7696 17.9487 10.7097 18.0376 10.6687 18.1358C10.6277 18.234 10.6066 18.3394 10.6065 18.4459C10.6095 18.6567 10.6947 18.8577 10.8436 19.0057C10.9925 19.1536 11.1932 19.2365 11.4022 19.2365ZM8.20809 7.01684V7.89401H9.78672V7.01684H8.20809Z" fill="#0DC1D9"/>
<path d="M3.4885 7.00721C3.02869 7.00721 2.56889 7.01002 2.10908 7.00721C1.77427 7.00721 1.60686 6.83447 1.60407 6.49463C1.60073 5.57526 1.60073 4.65627 1.60407 3.73765C1.60407 3.41356 1.77929 3.2397 2.10015 3.23858C3.01196 3.23558 3.92338 3.23558 4.83444 3.23858C5.16925 3.23858 5.34168 3.41413 5.3428 3.75115C5.3454 4.6634 5.3454 5.57545 5.3428 6.48732C5.3428 6.83672 5.16925 7.00721 4.82161 7.00889C4.37798 7.00946 3.93324 7.00721 3.4885 7.00721ZM4.44941 4.14726H2.5103V6.09178H4.44941V4.14726Z" fill="#0DC1D9"/>
<path d="M8.28658 21.2889C8.2871 21.5137 8.24359 21.7363 8.15857 21.9441C8.07354 22.1518 7.94866 22.3406 7.79111 22.4996C7.63355 22.6585 7.44641 22.7846 7.24042 22.8704C7.03444 22.9563 6.81366 23.0003 6.59077 23C6.14445 22.9963 5.71744 22.8159 5.40179 22.4978C5.08613 22.1796 4.90711 21.7491 4.90332 21.2991C4.9045 20.8452 5.08407 20.4103 5.40267 20.0897C5.72127 19.7691 6.15292 19.5889 6.60304 19.5886C7.04921 19.5913 7.47632 19.7714 7.79155 20.0897C8.10678 20.4081 8.28468 20.8391 8.28658 21.2889ZM7.39375 21.2833C7.38649 21.072 7.299 20.8715 7.14935 20.7234C6.99971 20.5752 6.79935 20.4906 6.58965 20.4872C6.37991 20.4936 6.18058 20.5808 6.03267 20.7309C5.88476 20.881 5.79952 21.0825 5.79448 21.294C5.79448 21.7312 6.18509 22.1143 6.61141 22.1008C6.82141 22.0926 7.02016 22.003 7.1663 21.8507C7.31244 21.6985 7.39471 21.4952 7.39599 21.2833H7.39375Z" fill="#0DC1D9"/>
<path d="M10.2557 10.5998C10.1396 10.6003 10.0277 10.5555 9.94368 10.4747C9.85962 10.394 9.80985 10.2835 9.8048 10.1665C9.80346 10.1066 9.81402 10.047 9.83585 9.99118C9.85769 9.9354 9.89036 9.88457 9.93195 9.8417C9.97353 9.79882 10.0232 9.76476 10.078 9.74151C10.1328 9.71825 10.1917 9.70628 10.2512 9.7063C10.3675 9.70805 10.4785 9.75548 10.5606 9.83849C10.6427 9.9215 10.6895 10.0336 10.6909 10.1508C10.6897 10.2678 10.6437 10.3797 10.5627 10.4634C10.4816 10.547 10.3716 10.5959 10.2557 10.5998Z" fill="#0DC1D9"/>
<path d="M7.03638 18.2107C7.03455 18.3277 6.98869 18.4396 6.90808 18.5238C6.82748 18.608 6.71815 18.6582 6.60224 18.6642C6.48619 18.6659 6.37403 18.622 6.28955 18.5417C6.20506 18.4615 6.1549 18.3512 6.14969 18.2343C6.1476 18.1744 6.15741 18.1147 6.17852 18.0586C6.19963 18.0026 6.23163 17.9514 6.27265 17.908C6.31366 17.8646 6.36285 17.8299 6.41734 17.8059C6.47183 17.782 6.53052 17.7692 6.58996 17.7684C6.70599 17.7717 6.8165 17.8191 6.8993 17.9012C6.9821 17.9832 7.03107 18.0938 7.03638 18.2107Z" fill="#0DC1D9"/>
</svg>

                    <span className="ml-2 text-xl text-black font-medium">
                      All stores
                    </span>
                  </div>
                  <DeliveryOption
                    resOption={resOption}
                    handleToggle={handleToggle}
                  />

                  <HygieneCheck
                    hygieneOption={hygieneOption}
                    handleToggle={handleToggle}
                  />
                  <button
                    type="button"
                    className="flex justify-between items-center py-4 cursor-pointer"
                    onClick={handleExpandToggle}
                  >
                    <span className="text-lg text-black font-medium">
                      Categories
                    </span>
                    <svg className={`arrow ${open ? '' : 'open'}`} width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.50834 6.4927C7.58784 6.39158 7.63401 6.31826 7.69299 6.25759C9.71132 4.2655 11.7297 2.27593 13.7531 0.288896C13.8788 0.167551 14.048 0.0639011 14.2173 0.0183964C14.4789 -0.0549166 14.7661 0.0992936 14.9046 0.331873C15.0457 0.56698 15.0303 0.865289 14.8585 1.0827C14.8097 1.14337 14.7533 1.19646 14.6994 1.25208C12.4939 3.42619 10.2909 5.6003 8.08537 7.77188C7.67247 8.1789 7.32369 8.1789 6.91336 7.77441C4.69242 5.58513 2.47149 3.39838 0.253117 1.2091C-0.172605 0.789448 -0.0418107 0.172607 0.499318 0.0285086C0.76347 -0.0422764 0.989154 0.0360927 1.17893 0.223167C1.56619 0.604901 1.95344 0.984106 2.34069 1.36584C3.99742 2.99895 5.65671 4.63459 7.31343 6.2677C7.36729 6.32332 7.41345 6.38399 7.50834 6.4927Z" fill="#0DC1D9"/>
</svg>
                  </button>

                  {open ? (
                    <Animate
                      play
                      start={{ opacity: 0, transform: "translateY(-10)" }}
                      end={{ opacity: 1, transform: "translateY(0)" }}
                      duration={0.5}
                    >
                      <div className="bg-white shadow-themeShadow lg:p-5 p-2 rounded-md ">
                        <ul className="">
                          {categories?.map((category) => {
                            return (
                              <li
                                key={category.id}
                                className="mt-4 flex items-center"
                              >
                                <input
                                  type="checkbox"
                                  // name=""
                                  // id="res1"
                                  checked={
                                    Checked.indexOf(category.name) === -1
                                      ? false
                                      : true
                                  }
                                  className="w-4 h-4 rounded-sm mr-2 text-[#0DC1D9]"
                                  onChange={() =>
                                    handleToggle(category.name, "category")
                                  }
                                />
                                <label
                                  htmlFor="res1"
                                  className="
                            text-gray-700
                            lg:text-md
                            text-sm
                            cursor-pointer
                          "
                                >
                                  {category.name}
                                </label>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </Animate>
                  ) : (
                    ""
                  )}

                  <FoodCategoryOption
                    foodCategories={foodCategories}
                    handleToggle={handleToggle}
                    foodCategoryOption={foodCategoryOption}
                  />
                </div>
                <div className="lg:flex-grow md:pl-5 lg:w-4/5 w-full mt-4 lg:mt-0">
                  <FoodCateroryMenubar
                    foodCategories={foodCategories?.filter(
                      (item) => item.featured === true
                    )}
                    handleToggle={handleToggle}
                    foodCategoryOption={foodCategoryOption}
                    address={getLocationFromLocalStorage()}
                  />

                  <div className="py-4 overflow-hidden">
                    <h3 className="text-black text-lg font-semibold">Offer</h3>
                    <div className="food_offer-slider mySwiper">
                      <Slider2 autoplay breakpoints={offBreakpoints}>
                        {restaurants
                          ?.filter((res) => res.discount_amount_percent > 0)
                          .map((item) => (
                            // console.log(item.name, item.branch_id),
<SwiperSlide key={item.branch_id}>
  {/* <Link to={`/restaurant/${item.branch_id}`}>
                              <div className="bg-white mt-6 shadow-themeShadow rounded-md relative">
                                <div className="flex">
                                  <img
                                    src={item.image}
                                    className="h-24 w-24 rounded-full -mt-5"
                                    alt=""
                                  />
                                  <div className="ml-4 py-4">
                                    <h4 className="text-base font-medium text-black">
                                      {item.name}
                                    </h4>
                                    <div className="mt-2">
                                      <p className="text-[#0DC1D9] text-base">
                                        {item.discount_amount_percent}% Off on
                                        every meal
                                      </p>
                                      <span className="text-gray-500 text-sm font-normal uppercase">
                                        Enjoy your every meal
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="after-content bg-[#0DC1D9] absolute h-8 w-8 top-0 right-0 rounded-bl-[20px]"></div>
                              </div>
                            </Link> */}
  <Link to={`/restaurant/${item.branch_id}`}>
                              <div className="
                              shadow-themeShadow rounded-md xl:w-[300px] xl:h-[200px] md:w-[250px] md:h-[200px] w-full h-full">
                                
                                  <img
                                    src={item.image}
                                    className="w-full h-full rounded-md"
                                    alt=""
                                  />
                                
                              </div>
                            </Link>
                            </SwiperSlide>
                            
                          ))}
                      </Slider2>
                    </div>
                  </div>
                  {loading ? (
                    <Loading />
                  ) : (
                    <div className="mt-4">
                      <div className="all-categori mb-5">
                        <h1 className="lg:text-lg text-base font-semibold text-black py-4">
                          Home made food
                        </h1>
                        <div className="relative">
                          <Slider2
                            autoplay
                            breakpoints={homeMadeBreakpoints}
                            allowSlideNext="true"
                          >
                            {restaurants
                              .filter((res) => res.is_home_made === true)
                              .map((filteredItem) => (
                               
                                <SwiperSlide key={filteredItem.branch_id}>
                                  <HomeMadeCard filteredItem={filteredItem} />
                                </SwiperSlide>
                              ))}
                          </Slider2>
                        </div>
                      </div>

                      {/* 50% off  */}
                      <div className="all-categori mb-5">
                        <div className="section-title">
                          <h4 className="lg:text-lg text-base font-semibold text-black py-4">
                            Up to 50% off
                          </h4>
                        </div>
                        {/*<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">*/}
                        <div className="relative">
                          <Slider2 autoplay breakpoints={offerBreakpoints}>
                            {restaurants.map((restaurant) => (
                              
                              <SwiperSlide key={restaurant.branch_id}>
                                <RestaurantListCard {...restaurant} />
                              </SwiperSlide>
                            ))}
                          </Slider2>
                         {restaurants?.length > 4 &&
                         <div>
                            <div className="swiper-button-next bg-white shadow-lg rounded-full h-12 w-12">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 currentColor text-indigo-800"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                              />
                            </svg>
                          </div>
                          <div className="swiper-button-prev bg-white shadow-lg rounded-full h-12 w-12">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 currentColor text-indigo-800"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                              />
                            </svg>
                          </div>
                         </div>
                       }
                        </div>
                      </div>

                      <div className="all-categori">
                        <div className="section-title">
                          <h4 className="lg:text-lg text-base font-semibold text-black py-4">
                            All Restaurant
                          </h4>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
                          {restaurants?.map((restaurant) => (
                            <RestaurantListCard
                              key={restaurant.id}
                              {...restaurant}
                            />
                          ))}
                        </div>
                      </div>
                      <div className="all-categori">
                       
                        <div className="grid grid-cols-2 gap-5 my-4">
                          <Link>
<img src={ad1} alt="" className="w-full rounded-lg cursor-pointer" />
                          </Link>
                          <Link>
<img src={ad2} alt="" className="w-full rounded-lg cursor-pointer" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SearchRestaurant;
